import React, { Component } from 'react'
import styled from 'styled-components'
import FooterBrand from './FooterBrand'
import FooterFeed from './FooterFeed'

const Container = styled.div`
  display: flex;
  display: -ms-flexbox;
`

export default class FooterSections extends Component {
  render () {
    if (!this.props.widgets) return null

    const {
      widgets
    } = this.props

    return (
      <Container>
        <FooterBrand widget={widgets.footerbrand}/>
        <FooterFeed widget={widgets.footersectionnews}/>
        <FooterFeed widget={widgets.footersectionmagazines}/>
        <FooterFeed widget={widgets.footersectionservices}/>
        <FooterFeed widget={widgets.footersectioncatalogues}/>
        <FooterFeed widget={widgets.footersectioncommunication}/>
      </Container>
    )
  }
}
